import { h, Key } from 'preact'
import { Highlight } from 'react-instantsearch-dom'
import TrackingLink from '../../link/tracking-link'

import {
  EventHit,
  Hit,
  SearchType,
  TopicClickedEvent,
  TopicClickedGoogleAnalyticsEvent,
  GetItemPropsFn,
  ZendeskHit,
  isCommunityResult,
  SalesforceHit,
  SkilljarHit
} from './'
import Icon from '../../assets'

interface Props {
  key: Key,
  hit: EventHit | Hit | ZendeskHit | SalesforceHit | SkilljarHit,
  isHighlited: boolean,
  track: TopicClickedEvent,
  gaEvents: TopicClickedGoogleAnalyticsEvent,
  getItemProps: GetItemPropsFn,
  type: SearchType,
  index: number
}

type SearchContentTypeIcon = 'article' | 'conversation' | 'question' | 'ideation' | 'answer' | 'externalLink' | 'calendar'

const SearchResult = (props: Props) => {
  const {
    key,
    hit,
    isHighlited,
    track,
    gaEvents,
    type,
    getItemProps,
    index
  } = props

  let icon: SearchContentTypeIcon = 'externalLink'
  if (isCommunityResult(hit)) {
    if (hit.content_type === 'question' && hit.has_answer) {
      icon = 'answer'
    } else if (hit.content_type === 'event') {
      icon = 'calendar'
    } else {
      icon = hit.content_type
    }
  }

  return <li
    key={key}
    className={`algolia-search-result algolia-search-result--${type}`}
    style={{ backgroundColor: isHighlited ? '#F2F2F2' : '' }}
    {...getItemProps({ item: hit, index })}
  >
    <TrackingLink target={!isCommunityResult(hit) ? '_blank' : ''} href={hit.topic_url || ''} track={track} gaEvents={gaEvents} className='algolia-hit-item button-click'>
      <Icon customClass='algolia-hit-item--icon' width={20} height={20} icon={icon} />
      <span className='algolia-hit-item--name'>
        {hit._highlightResult
          ? <Highlight attribute='title' hit={hit} tagName='strong' />
          : hit.title }
        {' '}
        { isCommunityResult(hit) && hit.content_type === 'article' && hit.article_label
          ? <span className='hit-item--meta'> {hit.article_label}</span>
          : null }
      </span>
    </TrackingLink>
  </li>
}

export default SearchResult
